export default __webpack_public_path__ + "static/media/Power_Małgorzata Szmigiel_Segregacja śmieci.21e7c3e8.pdf";